<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQueryCus">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory']" >
              <a-select showSearch optionFilterProp="children" v-model="queryParam.factoryId" :options="factoryOptions" :placeholder="language['common.pleaseInput']+language['factory']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['legalperson']">
              <a-select showSearch optionFilterProp="children" v-model="queryParam.legalpersonId" :options="legalpersonOptions" :placeholder="language['common.pleaseInput']+language['legalperson']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          
          <template v-if="toggleSearchStatus">
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['businessGroupName']">
                <a-select 
                :placeholder="language['common.pleaseInput']+language['businessGroupName']"
                v-model="queryParam.businessGroupId"
                :options="businessGroupOptions"
                @change="handleGroupVal" allowClear>
                </a-select>
              </a-form-item>
            </a-col>
                  
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['businessUnitName']">
                <a-select 
                :placeholder="language['common.pleaseInput']+language['businessUnitName']"
                v-model="queryParam.businessUnitId"
                :options="businessUnitOptions"
                allowClear>
                </a-select>
              </a-form-item>
            </a-col>
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['dangerLevel']">
                <j-dict-select-tag :placeholder="language['common.pleaseInput']+language['dangerLevel']" v-model="queryParam.dangerLevel" dictCode="ep_danger_level" allowClear/>
              </a-form-item>
            </a-col>
            
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item :label="language['inspectTime']">
                <j-date :placeholder="language['common.chooseStartDate']" class="query-group-cust" v-model="queryParam.startTime" ></j-date>
                <!-- <a-date-picker allowClear  format="YYYY-MM-DD"  placeholder="请选择开始日期" class="query-group-cust" v-model="queryParam.startTime"></a-date-picker> -->
                <span class="query-group-split-cust"></span>
                <j-date :placeholder="language['common.chooseEndDate']" class="query-group-cust" v-model="queryParam.endTime" ></j-date>
                <!-- <a-date-picker allowClear  format="YYYY-MM-DD"   placeholder="请选择结束日期" class="query-group-cust" v-model="queryParam.endTime"></a-date-picker> -->
              </a-form-item>
            </a-col>
            
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQueryCus" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchResetCus" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('隐患程度分析表')" >{{language['common.exportButton']}}</a-button>
      <!-- <a-button @click="handlerUpdate('1')" type="primary" :disabled="disabledState">复查维护</a-button>
      <a-button @click="handlerUpdate('2')" type="primary" :disabled="disabledState">申请延期</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <a-tabs>
      <a-tab-pane key="1" :tab="language['list.info.title']">
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
            <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
          </div>

          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            class="j-table-force-nowrap"
            :scroll="{x:true}"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
            @change="handleTableChange">

            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">{{language['common.edit']}}</a>

              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                      <a>{{language['common.delete']}}</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>

          </a-table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" :tab="language['histogram']">
        <template>
            <div style="overflow-x: scroll;">
              <v-chart :forceFit="false" width="2200" :height="height" :data="data">
                <v-tooltip />
                <v-axis />
                <v-legend />
                <v-stack-bar position="事业处*隐患数量" color="name" />
              </v-chart>
            </div>
        </template>
      </a-tab-pane>
    </a-tabs>

    <!-- <ep-danger-check-modal ref="modalForm" @ok="modalFormOk"/> -->
  </a-card>
</template>

<script>
  import { getAction, postAction,downFile } from '@/api/manage'
   import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import EpDangerCheckModal from './modules/EpDangerCheckModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  import moment from 'moment'
import { Calendar } from 'ant-design-vue'

  


  export default {
    name: "EpDangerCheckList",
    // mixins:[JeecgListMixin],
    components: {
      JDate
    },
    data () {
      return {
        sourceData:[],
        data:[],
        fields:[],
        height: 400,
        description: '隐患程度分析表',
        /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      /* 数据源 */
      dataSource:[],
      // 表格缓存的数据 - 用来点击取消时回显数据
      cacheData: [],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading:false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus:true,
        url: {
          list: "/epm/report/getDangerLevelReport",
          exportXlsUrl: "/epm/report/exportXls",
          queryFactoryList: '/sys/epFactory/list',
          queryLegalpersonList: '/sys/epPerson/list',
          queryEmployeeList: '/sys/employee/list',
          queryBusinessGroupList: "/sys/sysDepart/queryBusinessGroupList",
          queryBusinessUnitList: "/sys/sysDepart/queryBusinessUnitList"
        },
        dictOptions:{},
        superFieldList:[],
        factoryOptions: [],
        legalpersonOptions:[],
        inspectUserOptions:[],
        disabledState:true,
        id:'',
        businessGroupOptions:[],
        businessUnitOptions:[]
        
      }
    },
    created() {
      this.initQueryDate();
      this.searchQueryCus(1);
      this.getSuperFieldList();
      this.initfactoryList();
      this.initlegalpersonList();
      this.initemployeeList();
      this.initBusinessGroupList();
      
    },

    computed: {
      language() {
        return this.$store.getters.language
      },

      columns(){
              if(this.language){
                return  [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.language['factory'],
            align:"center",
            dataIndex: 'factoryName',

          },
          {
            title:this.language['legalperson'],
            align:"center",
            dataIndex: 'personName',
          },
          {
            title:this.language['businessGroupName'],
            align:"center",
            dataIndex: 'businessGroupName'
          },

          {
            title:this.language['businessUnitName'],
            align:"center",
            dataIndex: 'businessUnitName'
          },
          {
            title:this.language['levelNum1'],
            align:"center",
            dataIndex: 'levelNum1'
          },
          {
            title:this.language['levelNum2'],
            align:"center",
            dataIndex: 'levelNum2'
          },
          {
            title:this.language['levelNum3'],
            align:"center",
            dataIndex: 'levelNum3'
          },
          {
            title:this.language['levelNum4'],
            align:"center",
            dataIndex: 'levelNum4'
          },

          {
            title:this.language['totalSum'],
            align:"center",
            dataIndex: 'levelSum'
          }
        ]
            }
      },	
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initBusinessGroupList(){
        getAction(this.url.queryBusinessGroupList,{applicationCode:'env_audit'}).then(res=>{
          if(res.success){
            this.businessGroupOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id+""}
              return c;
            })
            console.log('this.businessGroupOptions: ',this.businessGroupOptions)
          }
        })
      },
      handleGroupVal(val){
        getAction(this.url.queryBusinessUnitList,{id:val}).then(res=>{
          if(res.success){
            this.businessUnitOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id+""}
              return c;
            })
          }
        })
      },
      initQueryDate(){
        this.queryParam = {startTime: this.getOneMonthDate(),endTime: this.getNowDate()}
      },
      getNowDate()
      {
          let month =parseInt(new Date().getMonth())+1;
          return new Date().getFullYear() + "-" + month + "-" + new Date().getDate();
      },
      getOneMonthDate(){
          const dates = new Date()
          dates.setMonth(dates.getMonth() - 1)
          let pastMonth = dates.getMonth() + 1
          let pastDay = dates.getDate()
          if (pastMonth >= 1 && pastMonth <= 9) {
            pastMonth = '0' + pastMonth
          }
          if (pastDay >= 0 && pastDay <= 9) {
            pastDay = '0' + pastDay
          }
          const endDate = dates.getFullYear() + '-' + pastMonth + '-' + pastDay
          return endDate
      },

      searchQueryCus(arg){
        if(!this.url.list){
        this.$message.error("请设置url.list属性!")
        return
        }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      this.loading = true;
      postAction(this.url.list, params).then((res) => {
        if (res.success) {
          const result = res.result.records || res.result
          this.dataSource = result.map((v, i)=>{
            v.key = i + 1;
            return v;
          }) 
          // this.cacheData = JSON.parse(JSON.stringify(res.result.records));
          
          if(res.result.total){
            this.ipagination.total = res.result.total;
          }else{
            this.ipagination.total = 0;
          }
          //处理图表数据
          console.log('this.dataSource-->',this.dataSource);

          let attr=['levelNum1','levelNum2','levelNum3','levelNum4'];
          let levela={name:this.language['levelNum1']};
          let levelb={name:this.language['levelNum2']};
          let levelc={name:this.language['levelNum3']};
          let leveld={name:this.language['levelNum4']};
          if(this.dataSource.length<=1){
              this.data= []
              return
          }
          attr.forEach((k)=>{
            this.dataSource.map((item,index,arr)=>{
              if(item.businessUnitName!='合计'){
                if(k=='levelNum1'){
                    let a ='\n\n\n\n'+ item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName;
                    let b = item.levelNum1;
                    levela[a] = b 
                } 
                if(k=='levelNum2'){
                    let a ='\n\n\n\n'+item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName;
                    let b = item.levelNum2;
                    levelb[a] = b 
                }
                if(k=='levelNum3'){
                    let a ='\n\n\n\n'+ item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName;
                    let b = item.levelNum3;
                    levelc[a] = b 
                }
                if(k=='levelNum4'){
                    let a ='\n\n\n\n'+ item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName;
                    let b = item.levelNum4;
                    leveld[a] = b 
                }
              }
              })
            })
                this.sourceData.push(levela);
                this.sourceData.push(levelb);
                this.sourceData.push(levelc);
                this.sourceData.push(leveld);
          console.log('this.sourceData==>',this.sourceData);
            this.dataSource.forEach((item)=>{
              if(item.businessUnitName!='合计'){
                this.fields.push('\n\n\n\n'+item.factoryName+',\n'+item.personName+',\n'+item.businessGroupName+',\n'+item.businessUnitName);
                }
              })
           console.log('this.fields==>',this.fields); 
            const DataSet = require('@antv/data-set');
            const dv = new DataSet.View().source(this.sourceData);
            dv.transform({
              type: 'fold',
              fields: this.fields,
              key: '事业处',
              value: '隐患数量',
            });
             this.data = dv.rows;
          
        }else{
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
        this.fields =[];
        this.sourceData=[];
      })
      },

      getQueryParams() {
      //获取查询条件
      let sqp = {}
      if(this.superQueryParams){
        sqp['superQueryParams']=encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      //稽查标识
      param.inspectFlag =1;

      return filterObj(param);
     },

     getQueryField() {
      //TODO 字段权限控制
      var str = "id,";
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex;
      });
      return str;
    },

    searchResetCus() {
      this.queryParam = {}
      this.searchQueryCus(1);
    },

    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },

    handleExportXls(fileName){
      if(!fileName || typeof fileName != "string"){
        fileName = "导出文件"
      }
      let param = this.getQueryParams();
      if(this.selectedRowKeys && this.selectedRowKeys.length>0){
        param['selections'] = this.selectedRowKeys.join(",")
      }
      console.log("导出参数",param)
      downFile(this.url.exportXlsUrl,param).then((data)=>{
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
        }else{
          let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName+'.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      })
    },
      
      handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      console.log(pagination)
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.searchQueryCus();
    },

      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        this.id = this.selectionRows[0].id;
        this.disabledState = this.selectionRows.length !== 1
      },

      /* handlerUpdate(key){
        this.$refs.modalForm.key = key;
        this.$refs.modalForm.id = this.id
        this.$refs.modalForm.add();
        this.$refs.modalForm.title = "整改维护";
        this.$refs.modalForm.disableSubmit = false;
      }, */

      //初始化厂区字典
      initfactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
            console.log('this.factoryOptions: ',this.factoryOptions)
          }
        })
      },

      //初始化法人字典
      initlegalpersonList(){
		  let para = {pageNo:1,pageSize:10000};
        getAction(this.url.queryLegalpersonList,para).then(res=>{
          if(res.success){
            this.legalpersonOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.legalpersonName, value: item.id+""}
              return c;
            })
            console.log('this.legalpersonOptions: ',this.legalpersonOptions)
          }
        })
      },
      //初始化人员典
      initemployeeList(){
        getAction(this.url.queryEmployeeList).then(res=>{
          if(res.success){
            this.inspectUserOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.realname, value: item.id+""}
              return c;
            })
            console.log('this.inspectUserOptions: ',this.inspectUserOptions)
          }
        })
      },
      backDepartInfo(info) {
        this.model.departIds = this.model.selecteddeparts;
        this.nextDepartOptions = info.map((item,index,arr)=>{
          let c = {label:item.text, value: item.value+""}
          return c;
        })
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
         fieldList.push({type:'string',value:'dangerNo',text:'隐患编号',dictCode:''})
         fieldList.push({type:'string',value:'dangerState',text:'隐患状态',dictCode:'ep_hiddanger_state'})
         fieldList.push({type:'string',value:'factoryId',text:'厂区',dictCode:'ep_bd_factory,factory_code,id'})
         fieldList.push({type:'string',value:'dangerAddress',text:'隐患地点',dictCode:''})
         fieldList.push({type:'string',value:'legalpersonId',text:'法人',dictCode:'ep_bd_legalperson,legalperson_code,id'})
         fieldList.push({type:'string',value:'businessGroupName',text:'事业群'})
         fieldList.push({type:'string',value:'businessUnitName',text:'事业处',dictCode:''})
         fieldList.push({type:'string',value:'dangerType',text:'隐患类型',dictCode:'ep_danger_type'})
         fieldList.push({type:'sel_search',value:'dangerSiteName',text:'隐患场所',dictTable:'ep_bd_danger_site', dictText:'', dictCode:'id'})
         fieldList.push({type:'string',value:'dangerDescription',text:'隐患描述',dictCode:''})
         fieldList.push({type:'string',value:'dangerLevel',text:'隐患程度',dictCode:'ep_danger_level'})
    //    fieldList.push({type:'date',value:'correctiveTerm',text:'整改期限',dictCode:'ep_corrective_term'})

        fieldList.push({type:'string',value:'correctiveType',text:'整改方式',dictCode:'ep_corrective_type'})
         fieldList.push({type:'sel_search',value:'inspectDepartName',text:'稽查部门',dictTable:'sys_depart', dictText:'depart_name', dictCode:'id'})
         fieldList.push({type:'sel_search',value:'inspectUserNames',text:'稽查人',dictTable:'sys_bm_employee', dictText:'realname', dictCode:'id'})
         fieldList.push({type:'date',value:'inspectTime',text:'稽查日期'})
         fieldList.push({type:'switch',value:'isPenalty',text:'设为罚扣'})
         fieldList.push({type:'double',value:'penaltyMoney',text:'罚扣金额',dictCode:''})
         fieldList.push({type:'string',value:'correctiveRequire',text:'整改要求',dictCode:''})
         fieldList.push({type:'string',value:'referenceFrame',text:'参考依据',dictCode:''})

         fieldList.push({type:'date',value:'planCheckDate',text:'计划复查日期'})
         fieldList.push({type:'list_multi',value:'dangerConfirmerNames',text:'现场确认人',dictTable:'sys_bm_employee', dictText:'realname', dictCode:'id'})
         fieldList.push({type:'sel_search',value:'supervisor',text:'责任主管',dictTable:'sys_bm_employee', dictText:'realname', dictCode:'id'})
         fieldList.push({type:'date',value:'confirmCorrectiveDate',text:'整改确认日期'})
         fieldList.push({type:'date',value:'confirmCheckDate',text:'复查确认日期'})
         fieldList.push({type:'string',value:'createBy',text:'创建人',dictCode:''})
         fieldList.push({type:'date',value:'createTime',text:'创建时间'})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  /deep/ .g2-tooltip{
      width: 200px !important;
    }
  
</style>